import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

function MobileMenu() {
  const location = useLocation();
  const navigate = useNavigate();

  const [isMenuVisible, setIsMenuVisible] = useState(window.innerWidth < 600);

  const handleClick = (path) => {
    if (location.pathname !== path) {
      navigate(path);
    }
  };

  const handleResize = () => {
    setIsMenuVisible(window.innerWidth <= 700);
  };

  useEffect(() => {
    handleResize(); // initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return (
    <>
      {/* Fixed top initials */}
      <div className="mobile-menu-top">
        <div className="mobile-initials">
          <a
            className={`mobile-menu-button ${
              location.pathname === "/" ? "active" : ""
            }`}
            id="mobile-initials"
            onClick={() => handleClick("/")}
          >
            ij
          </a>
        </div>
      </div>
    </>
  );
}

export default MobileMenu;
